import { Alert, Accordion, AccordionValue } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import Loader from '@/components/ui/Loader';
import { useSidebarNoteStore } from '@/stores/local/sidebar/SidebarNoteStore';

import Actions from '../Actions';
import InsightItem from '../InsightItem';

import { INSIGHTS_ACCORDION_ITEMS } from './config';
import { InsightsAccordionKeys } from './types';

import s from './InsightsLists.module.scss';

const InsightsLists: React.FC = () => {
  const {
    insights: { meta, activeItems, active, archive, isEmpty },
  } = useSidebarNoteStore();

  const handlerOnChange = React.useCallback(
    (value: AccordionValue<true>) => {
      activeItems.setKeys((value ?? []) as InsightsAccordionKeys[]);
    },
    [activeItems],
  );

  if (meta.isError) {
    return (
      <Alert className={s.root__alert} ml="lg" mr="lg" color="red">
        Не удалось загрузить инсайты
      </Alert>
    );
  }

  if (!meta.isStaleLoaded) {
    return <Loader gap={0} fullHeight type="dots" size="md" text="Ищу инсайты..." />;
  }

  if (isEmpty) {
    return (
      <Alert className={s.root__alert} ml="lg" mr="lg">
        Нет ни одного инсайта
      </Alert>
    );
  }

  return (
    <Accordion
      classNames={{
        root: s.root,
        control: s.root__control,
        content: s.root__content,
        label: s.root__label,
        chevron: s.root__chevron,
        item: s['root__accordion-item'],
      }}
      value={activeItems.keys}
      defaultValue={activeItems.keys}
      onChange={handlerOnChange}
      variant="filled"
      chevronPosition="left"
      multiple
      transitionDuration={300}
    >
      {INSIGHTS_ACCORDION_ITEMS.map(({ key, value }) => {
        const items = key === InsightsAccordionKeys.active ? active.items : archive.items;

        return (
          <Accordion.Item key={key} value={key}>
            <Accordion.Control>{value}</Accordion.Control>
            <Accordion.Panel c="inherit">
              {items.length > 0 ? (
                items.map((item) => <InsightItem key={item.id} model={item} actionSlot={<Actions model={item} />} />)
              ) : (
                <Alert ml="lg" mr="lg">
                  {key === InsightsAccordionKeys.active ? 'Нет активных инсайтов' : 'Нет инсайтов в архиве'}
                </Alert>
              )}
            </Accordion.Panel>
          </Accordion.Item>
        );
      })}
    </Accordion>
  );
};

export default observer(InsightsLists);
